<template>
  <div class="d-block d-sm-inline-block">
    <div class="d-block d-sm-inline-block">
      <label class="mt-2" for="day">วัน:</label>
    </div>
    <div class="d-block d-sm-inline-block input my-2 my-sm-0 mx-sm-2">
      <v-select
        id="day"
        :items="days"
        v-model="day"
        item-text="text"
        item-value="value"
        outlined
        dense
        hide-details/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      day: 1,
      days: [],
      daysInMonth: null,
    }
  },
  props: {
    value: { types: Number, require: true },
    year: { types: Number, require: true },
    month: { types: Number, require: true },
    daterange: { types: String, require: true },
  },
  mounted() {
    this.day = this.value
    this.genDays()
  },
  watch: {
    day (newVal, oldVal) {
      if (newVal !== oldVal) this.$emit('input', newVal)
    },
    value (newVal) {
      this.day = newVal
    },
    year () {
      this.genDays()
    },
    month () {
      this.genDays()
    },
  },
  methods: {
    genDays() {
      if(!(['day', 'week'].includes(this.daterange))) return
      const year = this.year
      const month = `${this.month+1}`.padStart(2, '0')
      const max = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
      if (this.daysInMonth == max) return
      if (this.day > max) this.day = max
      this.daysInMonth = max
      this.days = Array.from(Array(max), (_, i) => i + 1)
    },
  },
}
</script>